import React, { useEffect, useState, useCallback } from 'react';
import SubscribersTable from './SubscribersTable/SubscribersTable';
import { getSubscribersAPI } from '../../utils/APIs/subscribersApis';
import Loader from '../../Loader/Loader';

const Subscribers = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const LIMIT = 10;

  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const stored = sessionStorage.getItem("isSidebarOpen");
    return stored !== null ? JSON.parse(stored) : true;
  });

   useEffect(() => {
    const interval = setInterval(() => {
      const stored = sessionStorage.getItem("isSidebarOpen");
      const parsed = stored !== null ? JSON.parse(stored) : true;

      if (parsed !== isSidebarOpen) {
        setIsSidebarOpen(parsed);
      }
    }, 10);

    return () => clearInterval(interval);
  }, [isSidebarOpen]);


  const mapSubscriberResponse = (services = []) =>
    services.map((item) => ({
      id: item?._id,
      email: item?.email,
    }));

  const fetchData = useCallback(async (page) => {
    setLoading(true);
    try {
      const res = await getSubscribersAPI(page, LIMIT);
      setSubscribers(mapSubscriberResponse(res?.data?.data));
      setTotal(res?.data?.meta?.total || 0);
    } catch (err) {
      console.error("Subscribers fetch failed", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData(page);
  }, [fetchData, page]);

  const totalPages = Math.ceil(total / LIMIT);

  if (loading) return <Loader />;

  return (
    <div
      className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
      style={{ marginTop: "100px" }}
    >
      <div className="page-inner-wrapper">
        <h2 className="page-title">Subscribers</h2>

        <SubscribersTable data={subscribers} page={page} limit={LIMIT} />

        {total > LIMIT && (
          <div className="pagination">
            <button
              className="pagination-btn"
              disabled={page === 1}
              onClick={() => setPage((prev) => prev - 1)}
            >
              Prev
            </button>

            <span className="pagination-info">
              Page {page} of {totalPages}
            </span>

            <button
              className="pagination-btn"
              disabled={page === totalPages}
              onClick={() => setPage((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Subscribers;

// import React, { useEffect, useState } from 'react'
// import SubscribersTable from './SubscribersTable/SubscribersTable';
// import { getSubscribersAPI } from '../../utils/APIs/subscribersApis';
// import Loader from '../../Loader/Loader';
// import { useCallback } from 'react';

// const Subscribers = () => {
//   const [subscribers, setSubscribers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [page, setPage] = useState(1);
//   const [total] = useState(0);
//   const LIMIT = 10;
//   const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
//     const stored = sessionStorage.getItem("isSidebarOpen");
//     return stored !== null ? JSON.parse(stored) : true;
//   });

//   useEffect(() => {
//     const interval = setInterval(() => {
//       const stored = sessionStorage.getItem("isSidebarOpen");
//       const parsed = stored !== null ? JSON.parse(stored) : true;

//       if (parsed !== isSidebarOpen) {
//         setIsSidebarOpen(parsed);
//       }
//     }, 10);

//     return () => clearInterval(interval);
//   }, [isSidebarOpen]);

//   const mapSubscriberResponse = (services = []) =>
//     services.map((item) => ({
//       id: item?._id,
//       email: item?.email,
//       // isAdditionalServices: item?.isAdditionalServices

//     }));

//   const fetchData = useCallback(async (page) => {
//     setLoading(true);

//     try {
//       const res = await getSubscribersAPI();
//       console.log("RESPONSE", res?.data?.data)
//       setSubscribers(mapSubscriberResponse(res?.data?.data));
//       // setTotal(res?.data?.meta?.total);
//     } catch (err) {
//       console.error("Payments fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//  }, [page]);

//   useEffect(() => {
//   fetchData(page);
// }, [fetchData, page]);

//   const totalPages = Math.ceil(total / LIMIT);

//   if(loading){
//     return <Loader/>
//   }
//   return (

//     <div
//       className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"
//         }`}
//       style={{ marginTop: "100px" }}
//     >
//       <div className="page-inner-wrapper">
//         <h2 className="page-title">Subscribers</h2>

//         <SubscribersTable data={subscribers} />


//          {/* Pagination */}
//       {total > LIMIT && (
//   <div className="pagination">
//     <button
//       className="pagination-btn"
//       disabled={page === 1}
//       onClick={() => setPage(page - 1)}
//     >
//       Prev
//     </button>

//     <span className="pagination-info">
//       Page {page} of {totalPages}
//     </span>

//     <button
//       className="pagination-btn"
//       disabled={page === totalPages}
//       onClick={() => setPage(page + 1)}
//     >
//       Next
//     </button>
//   </div>
// )}
//       </div>
//     </div>
//   )
// }

// export default Subscribers